import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { useHasRights } from "../../contexts/UserRightsContext";
import { useDataFormatterHook } from "../../hooks/useDataFormatterHook";
import Loader from "../common/loader/Loader";
import { moveFormatter } from "../fomatters/BooleanFormatter";
import "./Data.css";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";

function createMaxLengthEditor(props) {
  // 'props' are automatically provided by react-bootstrap-table
  return (
    <input
      type="text"
      value={props.defaultValue} // Uses the cell's current value
      maxLength={10} // Sets the maximum length
      onChange={(e) => props.onChange(e.target.value)} // Updates the value on change
    />
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Data() {
  const [agents, setAgents] = useState([]);
  const [schema, setSchema] = useState();
  const [record, setRecord] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [redirect, setRedirect] = useState(null);
  const [showInfo, setshowInfo] = useState(true);
  const [renderShowsTotal, setrenderShowsTotal] = useState(true);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [value, setValue] = React.useState(0);
  const [selectedIdAgent, setSelectedIdAgent] = React.useState(0);
  const [selectedIdCurrency, setSelectedIdCurrency] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  let history = useHistory();

  const useStyles = makeStyles({
    root: {
      width: "100%",
      overflowX: "auto",
    },
    table: {
      minWidth: 650,
    },
    tableHead: {
      background: "#3f51b5",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "darkcyan !important",
      },
    },

    tableRow: {
      "&:hover": {
        backgroundColor: "lightgrey !important",
      },
    },
    headerCell: {
      color: "white",
    },
  });

  const classes = useStyles();

  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkMessage, setBulkMessage] = useState("");

  const handleBulkMessage = () => setShowBulkModal(true);

  const handleConfirmBulkMessage = () => {
    console.log("Mensaje enviado:", bulkMessage);
    let req = {
      IdAgent: 6559,
      Message: bulkMessage
    }
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Agent/AgentOnlineMessagesBulk",
      data: req,
    }).then((response) => {
      console.log("response", response);
      setShowBulkModal(false);
      setBulkMessage("");
      toast.success("Bulk message sent successfully");
    }).catch((error) => {
      console.error("Error:", error);
      toast.error("An error occurred while sending the message.");
    });;
  };

  const handleCancelBulkMessage = () => {
    setShowBulkModal(false);
    setBulkMessage("");
  };

  useEffect(() => {
    //Change for server api address
    setIsLoading(true);
    const url =
      process.env.REACT_APP_API2_URL +
      "/Agent/Agent_GetList2Result?idUser=" +
      userInfo.userId;
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setRecord(data[0]);
        setAgents(data);
        setIsLoading(false);
      }, 5000);
  }, []);

  function onAfterDeleteRow(rowKeys) {
    let deleteRequest = {
      IdAgent: rowKeys,
      IdUser: userInfo.IdUser,
    };
    console.log(deleteRequest);
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Agent/Agent_Delete",
      data: deleteRequest,
    }).then((response) => {
      console.log("response", response);
    });
    alert("The rowkey you drop: " + rowKeys);
  }

  function customConfirm(next, dropRowKeys) {
    const dropRowKeysStr = dropRowKeys.join(",");
    if (
      window.confirm(
        `(It's a custom confirm)Are you sure you want to delete ${dropRowKeysStr}?`
      )
    ) {
      // If the confirmation is true, call the function that
      // continues the deletion of the record.
      next();
    }
  }

  function selectedValues(row) {
    setRedirect(row);
  }

  const options = {
    page: 2, // which page you want to show as default
    sizePerPageList: [
      {
        text: "15",
        value: 15,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ], // you can change the dropdown list for size per page
    sizePerPage: 10, // which size per page you want to locate as default
    pageStartIndex: 0, // where to start counting the pages
    paginationSize: 3, // the pagination bar size.
    prePage: "Prev", // Previous page button text
    nextPage: "Next", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: renderShowsTotal, // Accept bool or function
    paginationPosition: "bottom", // default is bottom, top and both is all available
    // hideSizePerPage: true > You can hide the dropdown for sizePerPage
    // alwaysShowAllBtns: true // Always show next and previous button
    // withFirstAndLast: false > Hide the going to First and Last page button
    //expandRowBgColor: 'rgb(196, 222, 222)',
    afterDeleteRow: onAfterDeleteRow, // A hook for after droping rows.
    handleConfirmDeleteRow: customConfirm,
    onRowClick: selectedValues,
    afterInsertRow: onAfterInsertRow, // A hook for after insert rows
    btnGroup: (props) => customButtonGroup(props),
  };

  function customButtonGroup(props) {
    return (
      <div className="flex gap-3" role="group">
        {props.insertBtn}
        {props.deleteBtn}
        <button
          className="btn btn-warning"
          onClick={() => setShowBulkModal(true)}
        // style={{ marginLeft: "5px" }}
        >
          Bulk Message
        </button>
      </div>
    );
  }

  const cellEditProp = {
    mode: "click", //DBClick daba problemas con el Expand se cambio a click
    beforeSaveCell: onBeforeSaveCell, // a hook for before saving cell
    afterSaveCell: onAfterSaveCell, // a hook for after saving cell
  };
  const selectRowProp = {
    mode: "checkbox",

    //clickToSelect: false, // enable click to select

    clickToSelect: true, // click to select, default is false
    clickToExpand: true, // click to expand row, default is false
    //onSelect: onRowSelect,
  };

  function onAfterInsertRow(row, cellName, cellValue) {
    const data = {
      IdUser: Number(userInfo.userId),
      IdBook: Number(row.IdBook),
      IdAgentType: Number(row.IdAgentType),
      IdCurrency: Number(row.IdCurrency),
      Name: row.Name,
      Password: row.Password,
      Agent: row.Agent,
      Enable: row.Enable,
      OnlineAccess: row.OnlineAccess,
      IdLineType: null,
      IdGrouping: null,
      IdAgentPerHead: null,
      Distributor: null,
      IdLanguage: null,
      DontXfer: false,
      IsDistributor: false,
      Makeup: 0,
      CommSports: 0,
      CommCasino: 0,
      CommHorses: 0,
    };

    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Agent/Agent_Insert",
      data,
    })
      .then((response) => response.data)
      .then((IdAgent) => {
        if (IdAgent > 0) {
          setRedirect({
            IdAgent,
          });
        }
      });
  }

  function onAfterSaveCell(row, cellName, cellValue) {
    let AgentRequestDTO = {
      IdAgent: row.idAgent,
      Enable: row.enable,
      DontXferPlayerActivity: row.dontXferPlayerActivity,
      IsDistributor: row.isDistributor,
      Distributor: row.distributor,
      CommSports: row.commSports,
      CommCasino: row.commCasino,
      CommHorses: row.commHorses,
      IdAgentType: row.idAgentType,
      IdCurrency: row.idCurrency,
      IdBook: row.idBook,
      IdGrouping: row.idGrouping,
      Agent1: row.agent,
      Name: row.name,
      Password: row.password,
      City: row.city,
      State: row.state,
      Country: row.country,
      Address1: row.address1,
      Address2: row.address2,
      Email: row.email,
      Phone: row.phone,
      Fax: row.fax,
      Zip: row.zip,
      OnlineAccess: row.onlineAccess,
      OnlineMessage: row.onlineMessage,
      IdLineType: row.idLineType,
      IdAgentPerHead: row.idAgentPerHead,
      IdLanguage: row.idLanguage,
      LastModificationUser: userInfo.userId,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Agent/Agent_Update",
      data: AgentRequestDTO,
    }).then((response) => {
      if (response.data === "-1") {
        alert("Data Successfully Updated");
      }
      console.log("response", response);
    });
  }

  function onBeforeSaveCell(row, cellName, cellValue) {
    // You can do any validation on here for editing value,
    // return false for reject the editing
    return true;
  }

  const { values: agentTypes, formatter: agentTypeFormatter } =
    useDataFormatterHook({
      value: "idAgentType",
      text: "agentType",
      path: "/Agent/AgentType_GetList",
    });

  const { values: currencies, formatter: currencyFormatter } =
    useDataFormatterHook({
      value: "idCurrency",
      text: "currency",
      path: "/Agent/Currency_GetList",
    });

  const { values: books, formatter: bookFormatter } = useDataFormatterHook({
    value: "idBook",
    text: "description",
    path: "/Player/GetBooks",
  });

  const canDelete = useHasRights(23);

  if (redirect) {
    let pushURL = "/agentContainer/" + redirect.idAgent;
    return (
      <React.Fragment>
        {/* //this.props.location.state. asi se agarran los datos en el otro componente */}

        {console.log("Profile Info props", redirect)}
        <div>
          {history.push(pushURL)}

        </div>
      </React.Fragment>
    );
  }

  if (isLoading) return <Loader />;
  return (
    <Paper className={classes.root}>
      <h2>agents</h2>
      <Table className={classes.table} aria-label="simple table">
        <TableBody className={showInfo ? "show-table" : "hide-table"}>
          {agents && (
            <div>
              <BootstrapTable
                pagination={true}
                options={options}
                cellEdit={cellEditProp} //DBClick daba problemas con el Expand
                selectRow={selectRowProp} //Da problemas con el Expand
                insertRow={true}
                version="4"
                data={agents}
                deleteRow={canDelete}
                hover
              >
                <TableHeaderColumn
                  dataField="idAgent"
                  isKey
                  hidden
                  autoValue
                  hiddenOnInsert
                >
                  ID
                </TableHeaderColumn>
                <TableHeaderColumn
                  filter={{ type: "TextFilter", delay: 1000 }}
                  dataField="agent"
                >
                  Agent
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="idBook"
                  dataFormat={bookFormatter}
                  editable={{ type: "select", options: { values: books } }}
                >
                  Book
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="idAgentType"
                  dataFormat={agentTypeFormatter}
                  editable={{ type: "select", options: { values: agentTypes } }}
                >
                  Type
                </TableHeaderColumn>
                <TableHeaderColumn
                  filter={{ type: "TextFilter", delay: 1000 }}
                  dataField="name"
                >
                  Name
                </TableHeaderColumn>
                <TableHeaderColumn dataField="password">
                  Password
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="idCurrency"
                  dataFormat={currencyFormatter}
                  editable={{ type: "select", options: { values: currencies } }}
                >
                  Currency
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="enable"
                  dataAlign="center"
                  dataFormat={moveFormatter}
                  editable={{
                    type: "checkbox",
                    options: { values: "true:false" },
                  }}
                >
                  Enable
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="onlineAccess"
                  dataAlign="center"
                  dataFormat={moveFormatter}
                  editable={{
                    type: "checkbox",
                    options: { values: "true:false" },
                  }}
                >
                  Online Access
                </TableHeaderColumn>
              </BootstrapTable>

              {/* Modal de Bulk Message */}
              <Modal show={showBulkModal} onHide={handleCancelBulkMessage}>
                <Modal.Header closeButton>
                  <Modal.Title>Send Bulk Message</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <textarea
                    className="t-area"
                    rows="40"
                    placeholder="Write your message here..."
                    value={bulkMessage}
                    onChange={(e) => setBulkMessage(e.target.value)}
                  ></textarea>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCancelBulkMessage}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={handleConfirmBulkMessage}>
                    Confirm
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default Data;
